module.exports = __webpack_public_path__ + "img/avatar-8.bc11bfd1.jpg";